/**
 * Downloads a file from a presigned S3 URL.
 *
 * Deliberately uses fetch rather than the axios instance: our instance attaches an
 * Authorization header to every request, and S3 rejects a presigned GET that also
 * carries one. Falls back to opening the URL when the blob read is blocked by CORS.
 */
export const downloadFromPresignedUrl = async (presignedUrl: string, fileName: string): Promise<void> => {
  try {
    const response = await fetch(presignedUrl);
    if (!response.ok) {
      throw new Error(`Download failed with status ${response.status}`);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch {
    window.open(presignedUrl, '_blank', 'noopener,noreferrer');
  }
};

/** Saves a blob the server sent - a zip of invoices - under the given name. */
export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
